module.exports = __webpack_public_path__ + "static/media/run.5c7bc913.png";